import {useSchemaListCodelistIds} from 'schema/hooks/useSchemaListCodelistIds';
import {useAgentSchemas} from 'schemas/hooks/useAgentSchemas';

export const useAgentsCodelistIds = () => {
  const agentSchemas = useAgentSchemas();

  return useSchemaListCodelistIds(agentSchemas);
};
